import { Close, Done } from "@mui/icons-material";
import { Stack } from "@mui/material";
import CustomDataGrid from "components/customDataGrid";
import CustomDialog from "components/CustomDialog";
import { DATE_FORMAT, PLUGIN_NAME } from "config/const";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import moment from "moment";
import { useEffect, useState } from "react";

const BizsDetails = ({ data, setData, dialogTitle }) => {
    const [list, setList] = useState([])
    const { bt } = useBizTypeTranslation();

    useEffect(() => {
        if (data) {
            let bizList = []
            data?.bizList?.map((biz) => {
                const findMcs = data?.mcList?.filter(mc => mc?.business?._id === biz?._id) ?? []
                const obj = {
                    ...biz,
                    id: biz._id,
                    mcs: findMcs,
                    hasServicesCall: biz?.plugins.some(plugin => plugin.sysName === PLUGIN_NAME.SERVICES_CALL) ?? false,
                    hasMeterRead: biz?.plugins.some(plugin => plugin.sysName === PLUGIN_NAME.METER_READ) ?? false,
                    hasMicroControllers: biz?.plugins.some(plugin => plugin.sysName === PLUGIN_NAME.MICRO_CONTROLLERS) ?? false,
                }
                bizList.push(obj)
            })
            setList(bizList)
        }
    }, [data]);

    const onClose = () => { setData(null) };

    return (
        <CustomDialog width={1200} open={data ? true : false} onClose={onClose} title={dialogTitle}>
            <CustomDataGrid
                maxHeight={450}
                minHeight={450}
                borderRadius="10px 10px 10px 10px"
                columns={[
                    {
                        field: "name",
                        headerName: bt("NAME"),
                        filterable: true,
                        width: 150,
                    },
                    {
                        field: "mcsLength",
                        headerName: bt("MICRO_CONTROLLERS"),
                        filterable: false,
                        width: 70,
                        renderCell: (params) => {
                            return (
                                <Stack height="100%" justifyContent="center">
                                    {params.row.mcsLength > 0
                                        ? params.row.mcsLength
                                        : <Close sx={{ color: "error.text" }} />
                                    }
                                </Stack>
                            )
                        }
                    },
                    {
                        field: "hasServicesCall",
                        headerName: bt("SERVICE_CALLS"),
                        filterable: false,
                        width: 100,
                        renderCell: (params) => {
                            return (
                                <Stack height="100%" justifyContent="center">
                                    {params.row.hasServicesCall
                                        ? <Done sx={{ color: "success.main" }} />
                                        : <Close sx={{ color: "error.text" }} />
                                    }
                                </Stack>
                            )
                        }
                    },
                    {
                        field: "hasMeterRead",
                        headerName: bt("METER_READ"),
                        filterable: false,
                        width: 100,
                        renderCell: (params) => {
                            return (
                                <Stack height="100%" justifyContent="center">
                                    {params.row.hasMeterRead
                                        ? <Done sx={{ color: "success.main" }} />
                                        : <Close sx={{ color: "error.text" }} />
                                    }
                                </Stack>
                            )
                        }

                    },

                    {
                        field: "created",
                        headerName: bt("CREATED"),
                        filterable: false,
                        width: 150,
                        renderCell: (params) => {
                            return params?.value ? moment(params?.value).format(DATE_FORMAT) : "---"
                        }
                    },
                ]}
                list={list?.map((item) => ({
                    ...item,
                    id: item._id,
                    mcsLength: item?.mcs?.length ?? 0,

                })) ?? []}
            />
        </CustomDialog>
    );
};

export default BizsDetails;